module.exports = __webpack_public_path__ + "img/mile3m.12b6e5b1.jpg";